import {
  Callout,
  CalloutText,
  CalloutTitle,
  Container,
  Icon,
} from "design-react-kit";
import React from "react";
interface DoneProps {
  title: string;
  icon: string;
  body: string;
}

const Done: React.FC<DoneProps> = ({body,icon,title}) => (
    <Container className="d-flex justify-content-center" >
      <Callout color="note">
        <CalloutTitle>
          <Icon aria-hidden icon={icon} />
          {title}
        </CalloutTitle>
        <CalloutText>{body}</CalloutText>
      </Callout>
    </Container>
);

export default Done;
